import { array, bool, number, oneOf, shape, string } from "prop-types";

import addressProps from "./addressProps";
import buildingProps from "./buildingProps";

export const listingStatuses = [
  "closed",
  "delisted",
  "draft",
  "in_contract",
  "in_review",
  "lead",
  "open",
  "pending_approval",
  "sold",
  "temporary_off_market"
];

const listingProps = {
  address: shape(addressProps),
  agents: array,
  anyrooms_description: string,
  bathrooms: number,
  baths_description: string,
  bedrooms: number,
  bedrooms_description: string,
  building: shape(buildingProps),
  can_be_deleted: bool,
  can_be_edited: bool,
  can_be_featured: bool,
  closed_at: string,
  days_on_market: number,
  edit_url: string,
  featured_details: array,
  id: string,
  is_featured: bool,
  listed_price: number,
  open_houses: array,
  size_sqft: number,
  status: oneOf(listingStatuses),
  status_title: string,
  stale: bool,
  title_with_unit: string,
  unit_type: string,
  url: string,
  __typename: oneOf(["LocalSale", "Rental", "Sale", "AgentProfileListing"])
};

export default listingProps;
